export class CreateRegionRequestDTO {
  constructor(
    public region: string,
    public name: string,
  ) {}
}
export interface ICreateRegionRequest {
  region: string;
  name: string;
  default: boolean;
}
